function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import { tpl as l, fire as u } from "../utils/dom.js";
import { clamp as d } from "../utils/math.js";
var n = !1;
var c = function c(o) {
    return "touches" in o;
  },
  p = function p(o) {
    return n && !c(o) ? !1 : (n || (n = c(o)), !0);
  },
  a = function a(o, t) {
    var e = c(t) ? t.touches[0] : t,
      s = o.el.getBoundingClientRect();
    u(o.el, "move", o.getMove({
      x: d((e.pageX - (s.left + window.pageXOffset)) / s.width),
      y: d((e.pageY - (s.top + window.pageYOffset)) / s.height)
    }));
  },
  f = function f(o, t) {
    var e = t.keyCode;
    e > 40 || o.xy && e < 37 || e < 33 || (t.preventDefault(), u(o.el, "move", o.getMove({
      x: e === 39 ? .01 : e === 37 ? -.01 : e === 34 ? .05 : e === 33 ? -.05 : e === 35 ? 1 : e === 36 ? -1 : 0,
      y: e === 40 ? .01 : e === 38 ? -.01 : 0
    }, !0)));
  };
var v = /*#__PURE__*/function () {
  function v(t, e, s, r) {
    _classCallCheck(this, v);
    var h = l("<div role=\"slider\" tabindex=\"0\" part=\"".concat(e, "\" ").concat(s, "><div part=\"").concat(e, "-pointer\"></div></div>"));
    t.appendChild(h.content.cloneNode(!0));
    var i = t.querySelector("[part=".concat(e, "]"));
    i.addEventListener("mousedown", this), i.addEventListener("touchstart", this), i.addEventListener("keydown", this), this.el = i, this.xy = r, this.nodes = [i.firstChild, i];
  }
  return _createClass(v, [{
    key: "dragging",
    set: function set(t) {
      var e = t ? document.addEventListener : document.removeEventListener;
      e(n ? "touchmove" : "mousemove", this), e(n ? "touchend" : "mouseup", this);
    }
  }, {
    key: "handleEvent",
    value: function handleEvent(t) {
      switch (t.type) {
        case "mousedown":
        case "touchstart":
          if (t.preventDefault(), !p(t) || !n && t.button != 0) return;
          this.el.focus(), a(this, t), this.dragging = !0;
          break;
        case "mousemove":
        case "touchmove":
          t.preventDefault(), a(this, t);
          break;
        case "mouseup":
        case "touchend":
          this.dragging = !1;
          break;
        case "keydown":
          f(this, t);
          break;
      }
    }
  }, {
    key: "style",
    value: function style(t) {
      var _this = this;
      t.forEach(function (e, s) {
        for (var r in e) _this.nodes[s].style.setProperty(r, e[r]);
      });
    }
  }]);
}();
export { v as Slider };